import GenericRequest, { METHOD_GET } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';

export default class MachinesStateRequest extends GenericRequest {

    constructor(page, term = '') {
        super(METHOD_GET, ApiEndpoints.MACHINES_STATE);
    }

}



// WEBPACK FOOTER //
// ./src/app/machines/ws/MachinesStatesRequest.js